import styled from "styled-components";

export const ModalContainer = styled.div`
    width: 600px;
    position: fixed;
    background-color: white;
    /* border: solid 1px gray; */
    z-index: 99;
    top: 5vh;
    left: calc(50% - 300px);
    padding: 25px;
    overflow-y: auto;
    box-shadow: 0px 0px 16px rgba(8, 84, 117, 0.08);
    border-radius: 8px;
    @media (max-width: 650px) {
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 0;
        padding: 10px;
        /* overflow: scroll; */
    }
`
export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
export const IconCloseWrapper = styled.div`
  cursor: pointer;
`
export const ModalBody = styled.div`

`